import React, { PropTypes } from 'react'
import { Dialog, RaisedButton } from 'material-ui'
import MediaCreate from '../media/create'

const buttonStyle = {
  margin: '1em 1em 0 0'
}

class CreateMedia extends React.Component<any, any> {
  constructor () {
    super()
    this.state = {
      showMediaModal: false
    }
  }

  handleDialogOpen () {
    this.setState({
      showMediaModal: true
    })
  }

  handleDialogClose () {
    this.setState({
      showMediaModal: false
    })
  }

  handleMediaCreated (media) {
    this.handleDialogClose()
    this.props.onChange(null, media.id)
  }

  render () {
    return (
      <div>
        <RaisedButton
          label='Add new media'
          primary
          onClick={this.handleDialogOpen.bind(this)}
          style={buttonStyle}
        />
        <Dialog
          title='Add new media'
          modal={false}
          open={this.state.showMediaModal}
          onRequestClose={this.handleDialogClose.bind(this)}
        >
          <MediaCreate
// @ts-ignore
            onResourceCreated={(created) => {
              this.handleMediaCreated(created)
            }}
            noRedirect
            onCancel={this.handleDialogClose.bind(this)}
          />
        </Dialog>
      </div>
    )
  }
}

// @ts-ignore
CreateMedia.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired
}

// @ts-ignore
CreateMedia.defaultProps = {
  value: null
}

export default CreateMedia
